var $e69fac8c5f9d6043$exports = {};
$e69fac8c5f9d6043$exports = {
  "pending": `\u{4FDD}\u{7559}`
};
export { $e69fac8c5f9d6043$exports as default };